import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ChartComponent } from 'ng-apexcharts';
import { PageResult } from 'src/app/common/interfaces/paged-result.interface';
import { ChartOptions } from 'src/app/pages/charts/area/area.component';
import { Clientes } from 'src/app/pages/dashboards/factoring/interface/data.interface';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AddClientModalComponent } from 'src/app/pages/dashboards/factoring/modals/add-client-modal/add-client-modal.component';


@Component({
  selector: 'app-companys-un-executive-table',
  templateUrl: './companys-un-executive-table.component.html',
  styleUrls: ['./companys-un-executive-table.component.scss']
})
export class CompanysUnExecutiveTableComponent {
  @ViewChild('chart') chart: ChartComponent = Object.create(null);
  @ViewChild(MatSort, { static: true }) sort: MatSort = Object.create(null);
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator = Object.create(null);
  @Input() recieveFilterName: PageResult<Clientes>;
  @Input() proveedorCompany: PageResult<Clientes>;
  @Input() booleanFlag: boolean;
  @Input() booleanText: boolean;
  @Input() pagedProviderSummaries: PageResult<Clientes>;
  @Output() changePagination = new EventEmitter<any>();
  @Output() changeSorting = new EventEmitter<string>;
  public gredientChartOptions: Partial<ChartOptions> | any;
  public dataSource!: MatTableDataSource<Clientes>;
  public boardDeals: Array<Clientes>;
  public showText: boolean = false;

  displayedColumns: string[] = [
    'Name',
    'ClientRut',
    'SIIPasswordUpdate',
    'StartCurrentActivities',
    'IsSiiConnected',
  ];

  constructor(private router: Router, private dialog: MatDialog) { }

  ngAfterViewInit(): void { }

  ngOnInit() {
    this.setDataSource(this.pagedProviderSummaries);
    this.paginator._intl.itemsPerPageLabel = 'items por pagina';
  }

  ngOnChanges(changes: SimpleChanges) {
    this.setDataSource(this.pagedProviderSummaries);
    if (changes['pagedProviderSummaries']) {
      const newDeptors = changes['pagedProviderSummaries'].currentValue;
      const length = newDeptors.results.length;
      if (length == 0) {
        this.showText = false;
      }
      this.setDataSource(newDeptors);
    }

    if (changes['recieveFilterName']) {
      const newDeptorsFilter = changes['recieveFilterName'].currentValue;
      this.setDataSource(newDeptorsFilter);
    }
  }

  private setDataSource(dataSource: PageResult<Clientes>) {
    const {sortColumn, sortDirection} = dataSource;
    this.dataSource = new MatTableDataSource<Clientes>(dataSource?.results);
    this.paginator.length = dataSource?.totalRows;
    if(sortColumn && sortDirection){
      this.sort.active = sortColumn;
      this.sort.direction = sortDirection === 'asc' ? 'asc' : 'desc';
    }
  }

  public dealDialogOpen(args: any): void {
    this.router.navigate(['dashboards/files-clients'], {
      queryParams: { client: +args },
    });
  }

  public changePaginationTable(event: PageEvent) {
    this.changePagination.emit({
      page: event.pageIndex + 1,
      size: event.pageSize,
    });
  }

  public changeSortingTable(sortState: Sort) {
    if(sortState.direction === '') {
      this.changeSorting.emit('');
      return;
    }
    const sortOrder = `${sortState.active}_${sortState.direction}`;
    this.changeSorting.emit(sortOrder);
  }

  AddClient() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.panelClass = 'modalAddClient';
    const dialogRef = this.dialog.open(AddClientModalComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      console.log('El modal fue cerrado');
    });
  }

}
